module.exports = __webpack_public_path__ + "img/balkon a v solmsstr na.e792e9a9.jpg";